import { render, staticRenderFns } from "./ChannelConfigEditor.vue?vue&type=template&id=1dc4729e&scoped=true&lang=pug"
import script from "./ChannelConfigEditor.vue?vue&type=script&lang=js"
export * from "./ChannelConfigEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc4729e",
  null
  
)

export default component.exports